import "./actor.cb50ae3a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6TXE3 = parcelRequire("6TXE3");
var $2f1f675d78aa6223$exports = {};
$2f1f675d78aa6223$exports = import.meta.resolve("80wPj");


// start-snippet{displaymode.fitscreenandfill}
const $60be393394f97668$var$game = new $6TXE3.Engine({
    width: 600,
    height: 400,
    displayMode: $6TXE3.DisplayMode.FitScreenAndFill // highlight-line
});
// end-snippet{displaymode.fitscreenandfill}
const $60be393394f97668$var$playerImage = new $6TXE3.ImageSource((0, (/*@__PURE__*/$parcel$interopDefault($2f1f675d78aa6223$exports))));
const $60be393394f97668$var$loader = new $6TXE3.Loader([
    $60be393394f97668$var$playerImage
]);
$60be393394f97668$var$game.start($60be393394f97668$var$loader).then(()=>{
    const actor = new $6TXE3.Actor({
        pos: $60be393394f97668$var$game.screen.center
    });
    actor.graphics.use($60be393394f97668$var$playerImage.toSprite());
    $60be393394f97668$var$game.currentScene.onPreDraw = (ctx)=>{
        $60be393394f97668$var$game.screen.contentArea.draw(ctx, $6TXE3.Color.Yellow);
    };
    $60be393394f97668$var$game.currentScene.add(actor);
});


//# sourceMappingURL=fitscreenandfill.fc5945ab.js.map
